import type { Phase1JobPoll } from "./phase1Job";

/** Combined search + download progress (0–100). */
export function phase1OverallPercent(
  progress: Phase1JobPoll["progress"] | null | undefined,
): number {
  if (!progress) return 0;
  const queriesQueued = Number(progress.queries_queued ?? 0);
  const queriesDone = Number(progress.queries_done ?? progress.steps_total ?? 0);
  const scrapeTotal = Number(progress.scrape_total ?? 0);
  const scrapeDone = Number(progress.scrape_done ?? 0);
  const phase = String(progress.phase || "").toLowerCase();

  if (phase === "persisting") return 98;
  if (phase === "queued" || phase === "starting") return 0;

  const totalUnits = queriesQueued + scrapeTotal;
  if (totalUnits <= 0) {
    if (queriesQueued > 0) {
      return Math.min(99, Math.round((queriesDone / queriesQueued) * 100));
    }
    return 0;
  }
  return Math.min(99, Math.round(((queriesDone + scrapeDone) / totalUnits) * 100));
}

export function phase1CurrentActivityLine(
  progress: Phase1JobPoll["progress"] | null | undefined,
): string {
  if (!progress) return "";
  const activity = String(progress.current_activity || "");
  if (activity === "api_call") {
    const api = progress.current_api || "Search API";
    const idx = Number(progress.query_index ?? 0);
    const total = Number(progress.queries_queued ?? 0);
    const prefix = idx > 0 && total > 0 ? `Query ${idx}/${total}: ` : "";
    const preview = (progress.current_query_preview || "").trim();
    return preview
      ? `${prefix}Calling ${api} — “${preview.slice(0, 80)}${preview.length > 80 ? "…" : ""}”`
      : `${prefix}Calling ${api}…`;
  }
  if (activity === "downloading_page") {
    const url = (progress.current_url || "").trim();
    const title = (progress.current_title || "").trim();
    const label = title || url;
    if (label) {
      const short =
        label.length > 72 ? `${label.slice(0, 72)}…` : label;
      return `Downloading page: ${short}`;
    }
    return "Downloading evidence pages…";
  }
  if (activity === "saving_evidence") {
    return "Saving evidence to database…";
  }
  return "";
}
